// extracted by mini-css-extract-plugin
module.exports = {"listingSellerLogo":"ListingSellerLogo_listingSellerLogo__bMXNC"};